var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"app"}},[(_vm.$route.name === 'home')?_c(_setup.GlobalLayout,[_c('router-view')],1):_c('router-view'),_c(_setup.GlobalLoginDialog),_c(_setup.GlobalTrialDialog),_c(_setup.GlobalToast),_c(_setup.GlobalUserDrawer)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }